import React, { FC } from 'react';
import { Route } from 'react-router';
import { LoteEntryPage } from './LoteEntryPage';
import { LoteProductsPage } from './allproducts/LoteProductsPage';
import { CheckLoanFormat } from '../../../shared/components/CheckLoanFormat';
import { ProductSelectionProvider } from '../../../shared/product-selection/ProductSelectionContext';
import { Navigate, Routes } from 'react-router-dom';

const LoteRouteSwitch: FC = () => {
    return (
        <Routes>
            <Route index element={<Navigate to="all" replace />} />

            <Route
                path=":loanFormat"
                element={
                    <CheckLoanFormat>
                        <LoteEntryPage />
                    </CheckLoanFormat>
                }
            />

            <Route path=":languageId">
                <Route path="products">
                    <Route index element={<Navigate to="all" replace />} />
                    <Route
                        path=":loanFormat"
                        element={
                            <CheckLoanFormat>
                                <ProductSelectionProvider>
                                    <LoteProductsPage />
                                </ProductSelectionProvider>
                            </CheckLoanFormat>
                        }
                    />
                </Route>

                {/* PORTAL-3993 redirect all pages to products */}
                <Route path="featured" element={<Navigate to={'../products'} replace />} />
                <Route path="newlyadded" element={<Navigate to={'../products'} replace />} />
                <Route path="genres" element={<Navigate to={'../products'} replace />} />
            </Route>
        </Routes>
    );
};

export default LoteRouteSwitch;
